import "./ContactButton.scss";

export default function ContactButton(props: {
  content: string;
  classtitle: string;
}) {
  return <button className={props.classtitle}>{props.content}</button>;
}
